import React from "react";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import StyledFormInput from "components/FormInput/FormInput";
import StyledFormMaskedInput from "components/FormInput/FormMaskedInput";

import { styles } from "./styles";

interface AccountFieldsProps {
  isNewAccount: boolean;
}

export const AccountFields: React.FC<AccountFieldsProps> = ({
  isNewAccount,
}) => {
  return (
    <Box sx={isNewAccount ? styles.newAccountContainer : {}}>
      {isNewAccount && (
        <Typography data-testid="new-account-typography" sx={{ mb: 2 }}>
          Нові реквізити
        </Typography>
      )}
      <StyledFormInput
        title="Публічна назва компанії (необов’язково)"
        name="publicName"
        fullWidth
        slotProps={{ input: { inputProps: { maxLength: 70 } } }}
      />
      <StyledFormInput
        title="Юридична назва компанії або ФОП"
        name="organizationName"
        fullWidth
        slotProps={{ input: { inputProps: { maxLength: 70 } } }}
      />
      <StyledFormInput
        title="ЄДРПОУ/РНОКПП"
        name="identificationCode"
        fullWidth
        slotProps={{ input: { inputProps: { maxLength: 13 } } }}
        helperText="Для розрахунків з юридичною особою (ТОВ\ТзОВ) потрібен ЄДРПОУ, а для
        розрахунків з фізичною особою (ФОП) потрібен Ідентифікаційний код
        (РНОКПП)."
      />
      <StyledFormMaskedInput
        mask="UA 99 999999 99999 99999999999999"
        title="IBAN"
        name="iban"
        fullWidth
        slotProps={{ input: { inputProps: { inputMode: "numeric" } } }}
      />
    </Box>
  );
};
